import { CampaignData } from '@/typings/interfaces/data/campaign';
import { CampaignModel } from '@/models/CampaignModel';
import { State } from '@/store/modules/campaign/state';
import { MutationTree } from 'vuex';
import { events } from '@/services/events';
import { sdkEvents } from '@/sdk';
import { SdkFlowPageChangeEvent } from '@/sdk/events/flowPageChangeEvent';
import { FlowpageModel } from '@/components/layout/FlowpageModel';

export type Mutations<S = State> = {
  setDemoToken(state: S, demoToken: string): void;
  setData(state: S, data: CampaignData): void;
  setModel(state: S, model: CampaignModel): void;
  setCurrentFlowId(S: State, id: number): void;
  setPopoverId(S: State, id: number): void;
  setFictiveFlowPage(S: State, model: FlowpageModel): void;
  setNoMoreFlowPages(S: State, isTrue: boolean): void;
};

export const mutations: MutationTree<State> & Mutations = {
  setDemoToken: (state: State, demoToken: string) => {
    state.demoToken = demoToken;
  },
  setData: (state: State, data: CampaignData) => {
    state.data = data;
  },
  setModel: (state: State, model: CampaignModel) => {
    state.model = model;
  },
  setFictiveFlowPage: (state: State, model: FlowpageModel) => {
    state.fictiveFlowPage = model;
  },
  setNoMoreFlowPages(state: State, isTrue: boolean) {
    state.noMoreFlowPages = isTrue;
  },
  setCurrentFlowId: (state: State, id: number) => {
    state.fictiveFlowPage = undefined;
    if (state.flowId !== id) {
      const to = state.model?.getFlowPageModel(id);

      // TODO: See if we can also exclude this when there is no 'to'
      events.emit('flowPageChange', state.flowId ? state.model?.getFlowPageModel(state.flowId) : undefined, to);

      if (to) {
        sdkEvents.emit(
          'flowPageChange',
          new SdkFlowPageChangeEvent(to, state.flowId ? state.model?.getFlowPageModel(state.flowId) : undefined)
        );
      }
    }

    state.flowId = id;
  },
  setPopoverId: (state: State, id: number) => {
    state.popoverId = id;
  }
};
